import { render, staticRenderFns } from "./RoutineMaintenanceList.vue?vue&type=template&id=4565db24"
import script from "./RoutineMaintenanceList.vue?vue&type=script&lang=js"
export * from "./RoutineMaintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports